import React, { Component } from 'react';

class Proceso extends Component {

    componentDidMount(){
        $('[data-toggle="tooltip"]').tooltip();
    }

    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    handleTabLeftHover = (activate) => {
        const tooltip = document.querySelector('.procesoTabLeft [data-toggle="tooltip"]');
        tooltip.style.pointerEvents = activate ? 'auto' : 'none';
    }

    handleLineTooltipHover = (activate) => {
        const tooltip = document.querySelector('.tooltip-linea [data-toggle="tooltip"]');
        tooltip.style.pointerEvents = activate ? 'auto' : 'none';
    }

    render() {

        const {color, tipo, spinGear, nombre, estado, sumarDia} = this.props;

        let backColor = '';
        let inconoTipo = '';
        let horaInicio =  this.props.horaInicio ? this.props.horaInicio.substring(0,5) : '-';
        let horaFin = this.props.horaFin ? this.props.horaFin.substring(0,5) : '-';
        let tooltipIcono = '';
        let tooltipLinea = '';
        
        switch (color){
            case "VERDE" :
                backColor= ' procesoTabRightVerde',
                tooltipLinea = 'Procesamiento exitoso.'
            break;
            case "ROJO":
                backColor= ' procesoTabRightRojo',
                tooltipLinea = 'Procesamiento abortado.'
            break;
            case "AZUL":
                backColor= ' procesoTabRightAzul',
                tooltipLinea = 'Proceso en ejecución.'
            break;
            case "AMARILLO" :
                backColor= ' procesoTabRightAmarillo',
                tooltipLinea = 'Procesamiento con errores.'
            break;
        }

        switch (tipo){
            case "P" :
                inconoTipo= 'icono-gear procesoGear'
                tooltipIcono = 'Procesos.'
                break;
            case "I" :
                inconoTipo= 'icono-input procesoInput'
                tooltipIcono = 'Input.'
                break;
            case "O" :
                inconoTipo= 'icono-output procesoOutput'
                tooltipIcono = 'Output.'
            break;
        }
        
        return (
            <div className='tooltip-linea' onMouseEnter={() => this.handleLineTooltipHover(true)} onMouseLeave={() => this.handleLineTooltipHover(false)}>
            <div onClick={() => this.props.mostrarModal(3, true, { procesoTrazaId: this.props.trazaId })} className='row procesoTab tableroPointer' key={estado}>
                <div className='col-md-6 procesoTabLeft noPaddingRight' onMouseEnter={() => this.handleTabLeftHover(true)} onMouseLeave={() => this.handleTabLeftHover(false)}>
                    <div className='procesoColumnLeft height100'>
                        <div className={inconoTipo} data-toggle="tooltip" data-title={tooltipIcono} data-placement="right"></div>
                        <div className='procesoTabText height100'>
                            {nombre} <br></br>
                        </div>
                    </div>
                </div>
                <div className={'tableroProcesosPosicion ' + backColor} data-toggle="tooltip" data-title={tooltipLinea} data-placement="right">
                    <div className='inicioFinInfo'>
                        <span className='horaInicio'>{horaInicio}</span> | <span className='horaFin'>{horaFin} {sumarDia > 0 ? (" +" + sumarDia + "D") : ""}</span>
                    </div>
                    <div className='contenedorIcono'>
                        {spinGear && <div className='icono-spinGear'></div>}
                    </div>
                </div>
            </div>
        </div>        
        );
    }
}

export default Proceso;